import React from "react";
import { colors, resolveColor } from "utils/styles";

import Content from "./Content";
import Title from "./Title";

export default function ContactCallout(props) {
	const fields = props.data?.fields;

	return (
		<div className="callOut p-4 my-5 ContactCalloutComponent">
			<Content content={fields.content} />
			<Title title={fields.phoneNumber} />

			<style jsx="true">{`
				.callOut {
					background: ${resolveColor(fields.backgroundColor)};
					border-radius: 5px;
				}
			`}</style>
		</div>
	);
}
